import "./logo.scss";
import logo from "./logo.svg";
import {LinkInternal} from "../links";

export default function Logo() {
  return (
    <LinkInternal to={'/'}>
      <img className={'logo'} src={logo} alt={'Всесибирская олимпиада'}/>
    </LinkInternal>
  );
}
